import React from 'react';
import type { TableCellHeaderSortOptions } from 'app/components';

export type ConnectionsTableSortBy = 'connectionName' | 'logsCount' | 'eventsCount';

export type ConnectionsTableSort = {
  sortBy: ConnectionsTableSortBy;
  sortOrder: 'asc' | 'desc';
};

export type ConnectionsTableSortState = Record<ConnectionsTableSortBy, TableCellHeaderSortOptions>;

type UseConnectionsTableProps = {
  onSortChange?: (sort: ConnectionsTableSort) => void;
};

const INITIAL_SORT_STATE: ConnectionsTableSortState = {
  connectionName: null,
  logsCount: null,
  eventsCount: null,
};

export const useConnectionsTable = ({ onSortChange }: UseConnectionsTableProps) => {
  const [sortState, setSortState] = React.useState<ConnectionsTableSortState>(INITIAL_SORT_STATE);

  const handleSortChange = React.useCallback(
    ({ name, direction }: { name: string; direction: TableCellHeaderSortOptions }) => {
      const col = name as ConnectionsTableSortBy;
      const nextDirection: TableCellHeaderSortOptions =
        direction === null ? 'asc' : direction === 'asc' ? 'desc' : null;

      const newSortState: ConnectionsTableSortState = {
        ...INITIAL_SORT_STATE,
        [col]: nextDirection,
      };

      setSortState(newSortState);

      if (onSortChange && nextDirection !== null) {
        onSortChange({ sortBy: col, sortOrder: nextDirection });
      } else if (onSortChange && nextDirection === null) {
        onSortChange({ sortBy: 'connectionName', sortOrder: 'asc' });
      }
    },
    [onSortChange],
  );

  return { sortState, handleSortChange };
};
